<template>
  <div
    class="w-full shadow-lg border select-none border-gray-200 text-gray-800 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
    style="border-radius: 1rem"
  >
    <div style="border-radius: 1rem">
      <div
        class="panel-top flex no-select border-b px-2 bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700"
        style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
      >
        <div class="flex items-center justify-center text-white dark:text-dark-text">
          <span class="text-2xl material-icons mr-2"> {{ icon }} </span>
          <div class="text-lg font-bold">{{ title }}</div>
        </div>
        <div class="flex-grow" />
        <div>
          <IconButton
            :icon="buttonIcon"
            :padding_bottom="4"
            :padding_left="4"
            :padding_right="4"
            :padding_top="4"
            @click="click()"
          />
        </div>
      </div>
      <div class="w-full" style="border-bottom-right-radius: 1rem; border-bottom-left-radius: 1rem">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import IconButton from '@/presentation/components/Button/IconButton.vue'

export default defineComponent({
  name: 'BasePanel',
  components: { IconButton },
  props: {
    buttonIcon: {
      type: String,
      required: true
    },
    click: {
      type: Function,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(_, ctx) {
    return {}
  }
})
</script>

<style lang="postcss" scoped>
.panel-top {
  padding: 0.7em 1em 0.7em 1em;
}
</style>
